import { backendUrl } from "../../config/api";
import { API_METHOD_GET, API_METHOD_POST } from "../../config/constants";
import { getApiHeader } from "../../helper/apiActionHelper";
import { FORBIDDEN_ACTION, UNAUTHORIZED_USER } from "../types/authTypes";
import {
  DOWNLOAD_INVOICE_FILE,
  DOWNLOAD_INVOICE_FILE_LOADING,
  DOWNLOAD_PRICEBOOK_FILE_ERROR,
  DOWNLOAD_PRICEBOOK_FILE_LOADING,
  DOWNLOAD_PRICEBOOK_SUCCESS,
  SET_BILL_REDUCER,
} from "../types/billTypes";
import { COMMON_LOADING_RESET, COMMON_LOADING_SET } from "../types/commonTypes";

export const setBillReducer = (data) => {
  return (dispatch) => {
    dispatch({ payload: data, type: SET_BILL_REDUCER });
  };
};

export const downloadInvoiceFile = (docId, fileExtension, show = true) => {
  return (dispatch) => {
    dispatch({ type: DOWNLOAD_INVOICE_FILE_LOADING, payload: null });
    fetch(backendUrl + `/doc/${docId}/file/download`, {
      method: API_METHOD_GET,
      headers: getApiHeader(API_METHOD_GET, true, false),
    })
      .then((response) => {
        if (response.status === 500) {
          console.error("ERROR in blob");
          response
            .json()
            .then((data) => {
              alert(data?.message);
            })
            .catch((err) => {
              console.error("ERROR in blob", err);
              alert(err?.message);
            });
        } else if (response.status === 401 || response.status === 403) {
          dispatch({
            type: "AUTHENTICATION_ERROR",
          });
        } else if (response.status === 200) {
          response
            .blob()
            .then((blob) => {
              const data = window.URL.createObjectURL(blob);
              if (!show) {
                var link = document.createElement("a");
                link.href = data;
                link.download = Date.now() + "." + fileExtension;
                link.click();
              }
              setTimeout(function () {
                // For Firefox it is necessary to delay revoking the ObjectURL
                window.URL.revokeObjectURL(data);
              }, 1000);
              dispatch({ type: DOWNLOAD_INVOICE_FILE, payload: data });
            })
            .catch((err) => {
              console.error("ERROR in blob", err);
              alert(err?.message);
            });
        } else {
          console.error("ERROR in blob");
          alert("File download error");
        }
      })
      .catch((err) => {
        console.error("ERROR in catch", err);
        alert(err?.message);
      });
  };
};

export const downloadStoredExcel = (jobId, fileName) => {
  return (dispatch) => {
    dispatch({ type: DOWNLOAD_INVOICE_FILE_LOADING, payload: null });
    dispatch({
      type: COMMON_LOADING_SET,
    });
    fetch(backendUrl + `/job/${jobId}/excel`, {
      method: API_METHOD_POST,
      headers: getApiHeader(API_METHOD_GET, true, false),
    })
      .then((response) => {
        dispatch({
          type: COMMON_LOADING_RESET,
        });
        if (response.status === 500) {
          console.error("ERROR in blob");
          response
            .json()
            .then((data) => {
              alert(data?.message);
            })
            .catch((err) => {
              console.error("ERROR in blob", err);
              alert(err?.message);
            });
        } else if (response.status === 401 || response.status === 403) {
          dispatch({
            type: "AUTHENTICATION_ERROR",
          });
        } else if (response.status === 200) {
          response
            .blob()
            .then((blob) => {
              const data = window.URL.createObjectURL(blob);
              var link = document.createElement("a");
              link.href = data;
              link.download = fileName;
              link.click();
              setTimeout(function () {
                // For Firefox it is necessary to delay revoking the ObjectURL
                window.URL.revokeObjectURL(data);
              }, 1000);
              dispatch({ type: DOWNLOAD_INVOICE_FILE, payload: data });
            })
            .catch((err) => {
              console.error("ERROR in blob", err);
              alert(err?.message);
            });
        } else {
          console.error("ERROR in blob");
          alert("File download error");
        }
      })
      .catch((err) => {
        dispatch({
          type: COMMON_LOADING_RESET,
        });
        console.error("ERROR in catch", err);
        alert(err?.message);
      });
  };
};

export const downloadPriceBookExcel = (body) => {
  return (dispatch) => {
    dispatch({ type: DOWNLOAD_PRICEBOOK_FILE_LOADING, payload: null });
    fetch(backendUrl + `/pricebook/excel`, {
      method: API_METHOD_POST,
      headers: getApiHeader(API_METHOD_POST, true, false),
      body: JSON.stringify(body),
    })
      .then((response) => {
        if (response.status === 500) {
          console.error("ERROR in blob");
          response
            .json()
            .then((data) => {
              alert(data?.message);
            })
            .catch((err) => {
              console.error("ERROR in blob", err);
              alert(err?.message);
            });
        } else if (response.status === 401 || response.status === 403) {
          dispatch({
            type: "AUTHENTICATION_ERROR",
          });
        } else if (response.status === 200) {
          response
            .blob()
            .then((blob) => {
              const data = window.URL.createObjectURL(blob);
              var link = document.createElement("a");
              link.href = data;
              link.download = Date.now() + ".xlsx";
              link.click();
              setTimeout(function () {
                // For Firefox it is necessary to delay revoking the ObjectURL
                window.URL.revokeObjectURL(data);
              }, 1000);
              dispatch({ type: DOWNLOAD_PRICEBOOK_FILE_ERROR, payload: data });
            })
            .catch((err) => {
              console.error("ERROR in blob", err);
              alert(err?.message);
            });
        } else {
          console.error("ERROR in blob");
          alert("File download error");
        }
      })
      .catch((err) => {
        console.error("ERROR in catch", err);
        dispatch({ type: DOWNLOAD_PRICEBOOK_SUCCESS });
        alert(err?.message);
      });
  };
};

export const commonDocumentDownload = (file, docType) => {
  return (dispatch) => {
    dispatch({ type: COMMON_LOADING_SET });
    let formData = new FormData();
    formData.append("file", file);
    formData.append("docType", docType);
    fetch(backendUrl + `/document/common/upload`, {
      method: API_METHOD_POST,
      headers: getApiHeader(API_METHOD_POST, true, true),
      body: formData,
    })
      .then((response) => {
        dispatch({ type: COMMON_LOADING_RESET });
        if (response.status === 500) {
          console.error("ERROR in blob");
          response
            .json()
            .then((data) => {
              alert(data?.message);
            })
            .catch((err) => {
              console.error("ERROR in blob", err);
              alert(err?.message);
            });
        } else if (response.status === 401 || response.status === 403) {
          dispatch({
            type: "AUTHENTICATION_ERROR",
          });
        } else if (response.status === 200) {
          response
            .blob()
            .then((blob) => {
              const data = window.URL.createObjectURL(blob);
              var link = document.createElement("a");
              link.href = data;
              if (docType === "single-document-extractor")
                link.download = Date.now() + ".docx";
              else link.download = Date.now() + ".xlsx";
              link.click();
              setTimeout(function () {
                // For Firefox it is necessary to delay revoking the ObjectURL
                window.URL.revokeObjectURL(data);
              }, 1000);
            })
            .catch((err) => {
              console.error("ERROR in blob", err);
              alert(err?.message);
            });
        } else if (response.status === 401) {
          dispatch({ type: UNAUTHORIZED_USER });
          console.log("logout");
        } else if (response.status === 403) {
          dispatch({ type: FORBIDDEN_ACTION });
        } else {
          console.error("ERROR in blob");
          alert("File download error");
        }
      })
      .catch((err) => {
        dispatch({ type: COMMON_LOADING_RESET });
        console.error("ERROR in catch", err);
        dispatch({ type: DOWNLOAD_PRICEBOOK_SUCCESS });
        alert(err?.message);
      });
  };
};

export const commonPDFDocumentDownload = (documentId) => {
  return (dispatch) => {
    console.log("calling");
    dispatch({ type: COMMON_LOADING_SET });
    fetch(backendUrl + `/doc/${documentId}/export/pdf`, {
      method: API_METHOD_GET,
      headers: getApiHeader(API_METHOD_GET, true, true),
    })
      .then((response) => {
        dispatch({ type: COMMON_LOADING_RESET });
        if (response.status === 500) {
          console.error("ERROR in blob");
          response
            .json()
            .then((data) => {
              alert(data?.message);
            })
            .catch((err) => {
              console.error("ERROR in blob", err);
              alert(err?.message);
            });
        } else if (response.status === 401 || response.status === 403) {
          dispatch({
            type: "AUTHENTICATION_ERROR",
          });
        } else if (response.status === 200) {
          response
            .blob()
            .then((blob) => {
              const data = window.URL.createObjectURL(blob);
              var link = document.createElement("a");
              link.href = data;
              link.download = Date.now() + ".pdf";
              link.click();
              setTimeout(function () {
                // For Firefox it is necessary to delay revoking the ObjectURL
                window.URL.revokeObjectURL(data);
              }, 1000);
            })
            .catch((err) => {
              console.error("ERROR in blob", err);
              alert(err?.message);
            });
        } else if (response.status === 401) {
          dispatch({ type: UNAUTHORIZED_USER });
          console.log("logout");
        } else if (response.status === 403) {
          dispatch({ type: FORBIDDEN_ACTION });
        } else {
          console.error("ERROR in blob");
          alert("File download error");
        }
      })
      .catch((err) => {
        dispatch({ type: COMMON_LOADING_RESET });
        console.error("ERROR in catch", err);
        dispatch({ type: DOWNLOAD_PRICEBOOK_SUCCESS });
        alert(err?.message);
      });
  };
};

export const downloadHofPdf = (docGroupId) => {
  return (dispatch) => {
    console.log("calling");
    dispatch({ type: COMMON_LOADING_SET });
    fetch(backendUrl + `/api/hof/pdf`, {
      method: API_METHOD_POST,
      body: JSON.stringify({ docGroupId }),
      headers: getApiHeader(API_METHOD_POST, true, false),
    })
      .then((response) => {
        dispatch({ type: COMMON_LOADING_RESET });
        if (response.status === 500) {
          console.error("ERROR in blob");
          response
            .json()
            .then((data) => {
              alert(data?.message);
            })
            .catch((err) => {
              console.error("ERROR in blob", err);
              alert(err?.message);
            });
        } else if (response.status === 401 || response.status === 403) {
          dispatch({
            type: "AUTHENTICATION_ERROR",
          });
          dispatch({
            type: COMMON_LOADING_RESET,
          });
        } else if (response.status === 200) {
          response
            .blob()
            .then((blob) => {
              dispatch({
                type: COMMON_LOADING_RESET,
              });
              const data = window.URL.createObjectURL(blob);
              var link = document.createElement("a");
              link.href = data;
              link.download = Date.now() + ".pdf";
              link.click();
              setTimeout(function () {
                // For Firefox it is necessary to delay revoking the ObjectURL
                window.URL.revokeObjectURL(data);
              }, 1000);
            })
            .catch((err) => {
              console.error("ERROR in blob", err);
              alert(err?.message);
            });
        } else if (response.status === 401) {
          dispatch({ type: UNAUTHORIZED_USER });
          console.log("logout");
        } else if (response.status === 403) {
          dispatch({ type: FORBIDDEN_ACTION });
        } else {
          console.error("ERROR in blob");
          alert("File download error");
        }
      })
      .catch((err) => {
        dispatch({ type: COMMON_LOADING_RESET });
        console.error("ERROR in catch", err);
        dispatch({ type: DOWNLOAD_PRICEBOOK_SUCCESS });
        alert(err?.message);
      });
  };
};

export const downloadMarutiPdf = (jobId) => {
  return (dispatch) => {
    dispatch({
      type: COMMON_LOADING_SET,
    });
    fetch(backendUrl + `/maruti/job/${jobId}/get/pdf`, {
      method: API_METHOD_POST,
      headers: getApiHeader(API_METHOD_POST, true, false),
    })
      .then((response) => {
        if (response.status === 500) {
          dispatch({
            type: COMMON_LOADING_RESET,
          });
          console.error("ERROR in blob");
          response
            .json()
            .then((data) => {
              alert(data?.message);
            })
            .catch((err) => {
              console.error("ERROR in blob", err);
              alert(err?.message);
            });
        } else if (response.status === 401 || response.status === 403) {
          dispatch({
            type: COMMON_LOADING_RESET,
          });
          dispatch({
            type: "AUTHENTICATION_ERROR",
          });
        } else if (response.status === 200) {
          response
            .blob()
            .then((blob) => {
              dispatch({
                type: COMMON_LOADING_RESET,
              });
              const data = window.URL.createObjectURL(blob);
              var link = document.createElement("a");
              link.href = data;
              link.download = Date.now() + ".pdf";
              link.click();
              setTimeout(function () {
                // For Firefox it is necessary to delay revoking the ObjectURL
                window.URL.revokeObjectURL(data);
              }, 1000);
              dispatch({
                type: COMMON_LOADING_RESET,
              });
            })
            .catch((err) => {
              console.error("ERROR in blob", err);
              dispatch({
                type: COMMON_LOADING_RESET,
              });
              alert(err?.message);
            });
        } else {
          console.error("ERROR in blob");
          dispatch({
            type: COMMON_LOADING_RESET,
          });
          alert("File download error");
        }
      })
      .catch((err) => {
        console.error("ERROR in catch", err);
        dispatch({
          type: COMMON_LOADING_RESET,
        });
        alert(err?.message);
      });
  };
};

export const downloadMarutiExcel = (jobId, fileName) => {
  return (dispatch) => {
    dispatch({
      type: COMMON_LOADING_SET,
    });
    fetch(backendUrl + `/maruti/job/${jobId}/get/excel`, {
      method: API_METHOD_POST,
      headers: getApiHeader(API_METHOD_POST, true, false),
    })
      .then((response) => {
        dispatch({
          type: COMMON_LOADING_RESET,
        });
        if (response.status === 500) {
          console.error("ERROR in blob");
          response
            .json()
            .then((data) => {
              alert(data?.message);
            })
            .catch((err) => {
              console.error("ERROR in blob", err);
              alert(err?.message);
            });
        } else if (response.status === 401 || response.status === 403) {
          dispatch({
            type: "AUTHENTICATION_ERROR",
          });
        } else if (response.status === 200) {
          response
            .blob()
            .then((blob) => {
              const data = window.URL.createObjectURL(blob);
              var link = document.createElement("a");
              link.href = data;
              link.download = fileName;
              link.click();
              setTimeout(function () {
                // For Firefox it is necessary to delay revoking the ObjectURL
                window.URL.revokeObjectURL(data);
              }, 1000);
              dispatch({
                type: COMMON_LOADING_RESET,
              });
            })
            .catch((err) => {
              console.error("ERROR in blob", err);
              dispatch({
                type: COMMON_LOADING_RESET,
              });
              alert(err?.message);
            });
        } else {
          console.error("ERROR in blob");
          dispatch({
            type: COMMON_LOADING_RESET,
          });
          alert("File download error");
        }
      })
      .catch((err) => {
        dispatch({
          type: COMMON_LOADING_RESET,
        });
        console.error("ERROR in catch", err);
        alert(err?.message);
      });
  };
};
